window.$ = jQuery;

import "./import/modules";
import "./import/components";

import inView from './import/in-view.min';

$(document).ready(function() {

    inView('[data-visibly_list]>*')
        .on('enter', el => {
            el.classList.add("animated-fade")
        })
    inView('[data-visibly]')
        .on('enter', el => {
            el.classList.add("animated-fade")
        })


    inView.threshold(.15)
    inView('[data-visibly] img')
        .on('enter', el => {
            el.classList.add("visible")
        })
     inView('[data-visibly_list] img')
        .on('enter', el => {
            el.classList.add("visible")
        })



    function handleInputDevice(event) {
        document.body.dataset.input =
            event.type === 'mousedown' ? 'mouse' : 'keyboard';
    }

    window.addEventListener('mousedown', handleInputDevice, false);
    window.addEventListener('keydown', handleInputDevice, false);

});